/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sitesettings_Error_Title_Template1Inputs */

const vi_sitesettings_error_title_template1 = /** @type {(inputs: Sitesettings_Error_Title_Template1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mẫu tiêu đề phải có %s để đặt tiêu đề trang.`)
};

/**

* @param {Sitesettings_Error_Title_Template1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_error_title_template1 = /** @type {((inputs?: Sitesettings_Error_Title_Template1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Error_Title_Template1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_error_title_template1(inputs)
});
export { sitesettings_error_title_template1 as "siteSettings_error_title_template" }